var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAsteriksPt1 = function SvgAsteriksPt1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m8 8-.5-7h1zm0 0-.5 7h1zm0 0-5.812 3.933-.5-.866zm0 0 6.312-3.067-.5-.866zm0 0L1.688 4.933l.5-.866zm0 0 5.812 3.933.5-.866z"
  })));
};
export { SvgAsteriksPt1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgZD0ibTggOC0uNS03aDF6bTAgMC0uNSA3aDF6bTAgMC01LjgxMiAzLjkzMy0uNS0uODY2em0wIDAgNi4zMTItMy4wNjctLjUtLjg2NnptMCAwTDEuNjg4IDQuOTMzbC41LS44NjZ6bTAgMCA1LjgxMiAzLjkzMy41LS44NjZ6Ii8+PC9zdmc+Cg==";